module.exports = __webpack_public_path__ + "static/media/roboto-500.87284894.woff";